module.exports = __webpack_public_path__ + "static/img/netModel.2a409b31.png";